<template>
  <div class="perks">
    <div class="perks__title">
      <h2 class="perks__title--white">{{ $t('perks.title') }}</h2>
    </div>
    <div class="perks__body">
      <el-card :loading="contractsTransferLoading">
        <h3>{{ $t('perks.subtitle') }}</h3>
        <div class="perks__body__card">
          <div class="perks__body__card__body">
            <p v-html="$t('perks.presentation.text1')"></p>
            <p v-html="$t('perks.presentation.text2')"></p>
            <p v-html="$t('perks.presentation.text3')"></p>
            <template v-if="!contractsTransferLoading">
              <p v-if="!showChoice"
              class="perks__body__card__status">{{ statusText }}</p>
              <el-link
                v-if="!showChoice && modifiable"
                type="primary"
                @click="showChoice = true;">
                Modifier
              </el-link>
              <div class="perks__body__card__actions" v-if="showChoice">
                <el-button
                  :disabled="contractsTransferLoading"
                  type="success"
                  @click="transfer(1)">
                  {{ $t('perks.contracts.choices.yes') }}
                </el-button>
                <div class="perks__body__card__actions__decline">
                  <el-link
                    type="secondary"
                    :disabled="contractsTransferLoading"
                    @click="confirmNo()"
                    v-html="$t('perks.contracts.choices.no')">
                  </el-link>
                </div>
              </div>
            </template>
            <div class="u-text-align-center" v-else>
              <loading-icon class="--secondary" />
            </div>
          </div>
          <div class="perks__body__card__partners">
            <img
              :class="['perks__body__card__partners__logo',
            `perks__body__card__partners__logo__${partner}`]"
              v-for="(partner, index) in partners"
              :key="index"
              :index="index"
              :src="'https://cdn.nextories.com/static/img/partenaires/logo-' + partner + '.png'"
            />
          </div>
        </div>
      </el-card>
      <el-card class="perks__body__service">
        <h3>{{$t('perks.partner.title')}}</h3>
        <p class="perks__body__service__text" v-html="$t('perks.partner.text')"></p>
        <el-link
          v-for="sector in sectors"
          :key="`service-link-${sector.title[0].text}`"
          :underline="false"
          class="perks__body__service__link button-link el-link--default"
          :href="`#${sector.title[0].text}`">
          <prismic-rich-text :field="sector.title"/>
        </el-link>
        <template v-for="sector in sectors">
            <service v-if="sector.items && sector.items.length"
                     :key="`service-card-${sector.title[0].text}`"
                     :id="sector.title[0].text"
                     class="perks__body__service__card"
                     :partners="sector.items" :nameService="sector.title"></service>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadingIcon from '@/utils/components/LoadingIcon.vue';
import Service from '@/components/perks/Service.vue';

export default {
  name: 'perks',
  components: {
    Service,
    LoadingIcon,
  },
  data() {
    return {
      sectors: [],
      transferActive: null,
      showForm: false,
      modifiable: true,
    };
  },
  computed: {
    ...mapGetters({
      contractsTransferLoading: 'demandStore/contractsTransferLoading',
      contractsTransfer: 'demandStore/contractsTransfer',
      projectSelected: 'projectStore/projectSelected',
    }),
    showChoice: {
      get() {
        return (
          this.showForm
          || this.contractsTransfer === null
          || this.contractsTransfer === 2
        );
      },
      set(value) {
        this.showForm = value;
      },
    },
    statusText() {
      if (this.contractsTransfer === 0) {
        return this.$t('perks.message.declined');
      }
      return this.$t('perks.message.accepted');
    },
    partners() {
      return [
        'bouygues',
        'direct-assurance',
        'engie',
        'eni',
        'free',
        'la-poste',
        'orange',
        'sfr',
        'red',
        'total-direct-energie',
      ];
    },
  },
  methods: {
    ...mapActions({
      getContractsTransfer: 'demandStore/getContractsTransfer',
      postContractsTransfer: 'demandStore/postContractsTransfer',
    }),
    async getContent() {
      try {
        const response = await this.$prismic.client.getSingle('nxt_perks');
        this.sectors = response && response.data && response.data.nxt_perks.body.value.map((f) => ({
          title: f['non-repeat'].title.value,
          items: f.repeat.map((item) => ({
            link: item.card_link,
            content: item.card_additional_info.value,
            title: item.card_title.value,
            image: item.image.value.main,
          })),
        }));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    confirmNo() {
      this.$confirm(
        this.$t('perks.confirmNoContracts.text'),
        this.$t('perks.confirmNoContracts.title'),
        {
          customClass: 'confirm__modal',
        },
      ).then(() => {
        this.transfer(0);
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.err(e);
      });
    },
    async transfer(choice) {
      try {
        this.showChoice = false;
        const result = await this.postContractsTransfer(
          { requested_transfer: choice, showAlert: false },
        );
        this.modifiable = result.modifiable ?? true;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    async getContractsTransferValue() {
      try {
        const result = await this.getContractsTransfer();
        this.modifiable = result.modifiable ?? true;
      // eslint-disable-next-line no-empty
      } catch (e) {}
    },
  },
  watch: {
    async projectSelected() {
      this.stepSelectedKey = null;
      this.isMessageVisible = false;
      await this.getContractsTransferValue();
    },
  },
  async created() {
    this.getContent();
    await this.getContractsTransferValue();
  },
};
</script>

<style lang="scss" scoped>
.perks {
  min-height: 600px;
  margin: 0;
  @include breakpoint(tablet) {
    margin: 0 20px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin;;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin;
  }
  &__title {
    margin-top: 20px;
    margin-left: 20px;
    @include breakpoint(tablet) {
      margin-left: 0px;
    }
    &--white {
      color: $--color-white;
    }
  }
  &__body {
    position: relative;
    margin: 20px 0;
    &__card {
      border-radius: 0;
      @include breakpoint(tablet) {
        border-radius: 4px;
        display: flex;
        align-items: flex-start;
      }
      &__status {
        font-weight: 600;
        color: $--color-secondary;
      }
      &__actions {
        margin-top: 20px;
        margin-bottom: 5px;

        &__decline {
          margin-top: 10px;
        }
      }
      &__partners {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        @include breakpoint(tablet) {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-template:
          "bouygues direct-assurance engie eni"
          ". free la-poste orange"
          ". . sfr red"
          ". . . total-direct-energie";
          gap: 10px;
          margin-top: 0;
          margin-left: 20px;
        }
        &__logo {
          max-width: 70px;
          @include breakpoint(tablet) {
            max-width: 80px;
            justify-self: center;
            align-self: center;
          }

          @each $i in bouygues, direct-assurance, engie, eni,
                      free, la-poste, orange, sfr, red, total-direct-energie {
            &__#{$i} {
              grid-area: $i;
            }
          }
        }
      }
    }
    &__service {
      margin-top: 20px;
      &__text {
        margin-bottom: 17px;
      }
      &__link{
        &:not(last-child) {
          margin-right: 17px;
          margin-bottom: 10px;
        }
        :deep(h3) {
          color: inherit;
          margin: inherit;
          font-size: inherit;
        }
      }
      &__card {
        margin-top: 25px;
      }
    }
  }
}
</style>
